import { type CalendarConfig } from './availability-reservation-calendar.model';

export const DEFAULT_CALENDAR_CONFIG: Required<CalendarConfig> = {
  showInternalInfoOnBlock: true,
  showTimeOnBlock: true,
  showDetailedStatus: true,
  showHeaderHours: true,
  allowMaintenance: false,
  interactiveOccupiedBlocks: false,
};

export const OCCUPIED_STATUS = 'bloqueada';

export const ALL_COURTS_FILTER = 'all';

/** Hour (24h) at which the header switches from the day icon/style to the night one */
export const NIGHT_STARTS_AT_HOUR = 18;
export const DAY_HOUR_ICON = '☀️';
